import { FavouriteConditionValue } from 'app/types-shared';
import { ConditionValuesOperator, OptionTypes, FilterTypes } from 'app/components/filters/types';

export const createInitialDateFieldConditions = (favouriteConditionValue: FavouriteConditionValue,
  conditionValues: FavouriteConditionValue[]) => {

  if (favouriteConditionValue.operator && favouriteConditionValue.operator.v === ConditionValuesOperator.empty) {
    return {
      [FilterTypes.DateField]: { type: OptionTypes.NotSpecified }
    };
  }

  if (favouriteConditionValue.operator &&
    (favouriteConditionValue.operator.v === ConditionValuesOperator.largerOrEqual ||
      favouriteConditionValue.operator.v === ConditionValuesOperator.less)) {
    return {
      [FilterTypes.DateField]: {
        value: favouriteConditionValue.date,
        type: OptionTypes.SpecificPeriodRange
      }
    };
  }

  return {
    [FilterTypes.DateField]: {
      value: favouriteConditionValue.periodPredef ? favouriteConditionValue.periodPredef.v : undefined,
      description: favouriteConditionValue.periodPredef ? favouriteConditionValue.periodPredef.d : undefined,
      type: OptionTypes.FixedPeriod
    }
  };
};
